// Libraries
import {
  Pipe,
  PipeTransform
} from '@angular/core';
import * as lodash from 'lodash';

/**
 * `PercentagePipe` calcule and transform the report value
 *
 * @author Lautaro Klein <lautaro.klein@woopasoft.com>
 * @export
 */
@Pipe({
  name: 'wpPercentage'
})
export class PercentagePipe implements PipeTransform {
  transform(value: number, total: number, decimal: number): string {
    // Check inputs
    if (!lodash.isNumber(value) || !lodash.isNumber(total)) {
      return '';
    }
    // Calcule fulfillment report percentage
    const percentage = total !== 0 ? value * 100 / total : 0;
    // Convert to correct format
    return percentage.toFixed(decimal);
  }
}
